import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import {
  ChangeDetectionStrategy,
  Component,
  computed,
  inject,
  input,
} from '@angular/core';
import { esIconoPrime, resolverIcono } from '../../layout/app-sidebar/icon-registry';

/**
 * Renderiza un icono por código, resolviéndolo contra el registro central
 * (`icon-registry.ts`). Un código `pi pi-xxx` se muestra como icono PrimeNG;
 * cualquier otro se dibuja como SVG Góndola (desconocido → `default`).
 *
 * El SVG proviene de constantes controladas por el proyecto, por eso se marca como
 * confiable; nunca recibe HTML externo.
 */
@Component({
  selector: 'app-icon',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    @if (esPrime()) {
      <i [class]="name()"></i>
    } @else {
      <svg
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
        class="h-full w-full"
        [innerHTML]="svg()"
      ></svg>
    }
  `,
})
export class AppIconComponent {
  private readonly sanitizer = inject(DomSanitizer);
  readonly name = input.required<string>();

  protected readonly esPrime = computed(() => esIconoPrime(this.name()));
  protected readonly svg = computed<SafeHtml>(() =>
    this.sanitizer.bypassSecurityTrustHtml(resolverIcono(this.name())),
  );
}
